module.exports = __webpack_public_path__ + "static/media/arrow-off-leste.fe47ce92.png";